import React from "react";
import { View, Text } from "react-native";
import {
  BG_STYLES,
  Button,
  BUTTON_TYPE,
  COLORS,
  COMMON_STYLES,
  SUBHEADING_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import { useTranslation } from "react-i18next";

interface Props {
  onClose: () => void;
  onClearAll: () => void;
}

const FilterHeader = ({ onClose, onClearAll }: Props) => {
  const { t } = useTranslation();
  return (
    <View
      style={[
        COMMON_STYLES.row,
        COMMON_STYLES.justifyBetween,
        COMMON_STYLES.el1,
        COMMON_STYLES.p1,
        COMMON_STYLES.divider,
        BG_STYLES.bgWhite,
        COMMON_STYLES.alignItemsCenter,
        { shadowColor: COLORS.black },
      ]}
    >
      <View style={COMMON_STYLES.row}>
        <Text
          style={[
            SUBHEADING_STYLES.MEDIUM_S3,
            TEXT_STYLES.textNeutral90,
            COMMON_STYLES.ml1,
          ]}
        >
          Filters
        </Text>
      </View>
      <Button
        type={BUTTON_TYPE.TERTIARY}
        text={t("clear_all")}
        onClick={onClearAll}
        textStyle={[TYPOGRAPHY.TEXT2, VARIANTS_STYLES.SEMI_EMPHASIZED]}
      />
    </View>
  );
};

export default FilterHeader;
